export default {
  data () {
    return {
      step: 'base'
    }
  },
  watch: {
    '$route.query.step' () {
      this.updateStep()
    }
  },
  mounted () {
    this.updateStep()
  },
  computed: {
    isStepBase () {
      return this.step === 'base'
    },
    isStepSite () {
      return this.step === 'site'
    }
  },
  methods: {
    updateStep () {
      const { step } = this.$route.query

      if (step) {
        this.step = step
        return
      }

      this.step = 'base'
    }
  }
}
